// extracted by mini-css-extract-plugin
module.exports = {"Languages":"Languages_Languages__NvcqE","Icon":"Languages_Icon__2Uj3N","LanguagesSelect":"Languages_LanguagesSelect__2_B7h","minimalist":"Languages_minimalist__3sDiW"};